import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=c4b345dc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b345dc')) {
      api.createRecord('c4b345dc', component.options)
    } else {
      api.reload('c4b345dc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=c4b345dc&", function () {
      api.rerender('c4b345dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o3vMBJpN8eFX/JS/videoIframe.vue"
export default component.exports